import { PickersDay as MuiPickersDay, PickersDayProps } from '@mui/x-date-pickers';

export const PickersDay = <TDate,>(props: PickersDayProps<TDate>) => (
  <MuiPickersDay
    sx={(theme) => ({
      borderRadius: '8px',
      '&.Mui-selected': {
        backgroundColor: `${theme.palette.secondary.main} !important`
      },
      '&.MuiPickersDay-today': {
        color: theme.palette.secondary.main,
        border: 0,
        '&.Mui-selected': {
          color: 'white'
        }
      }
    })}
    {...props}
  />
);
